import {useParams, useLocation, NavLink, useNavigate} from "react-router-dom"
// import catData from "./categories_sample"
import QueryGroup from "../_subcomponents/QueryGroup";
import Button from "../../components/Button";
import {useContext, useEffect, useState, useRef} from "react";
import {IBlock, IMapData} from "../../helpers/Interfaces";
import AuthContext from "../../context/AuthContext";
import {Alert, AlertTitle} from "@mui/material";
import CheckCondObject from "../_subcomponents/CheckCondObject";
import BreadCrumbs from "../../components/BreadCrumbs";
import MapToolsBase from "../_subcomponents/MapToolsBase"
import AutocOneFieldUsemap from "../_subcomponents/AutocOneFieldUsemap";
import * as React from "react";


export default function FieldMap() {
    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)

    let {prjid, field_pk, usemap} = useParams()
    const navigate = useNavigate()
    // const location = useLocation()
    // console.log(location.state)

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Fields List', 'link': '../1'},
        {'name': 'Target field map', 'link': ''}
    ]

    const keyDataSet: any = {
        mapType: 'field',
        projUID: String(prjid),
        fieldUID: field_pk
    }

    const dragElem = useRef(undefined)

    // const [isSaved, setIsSaved] = useState(false)
    const [saveStatus, setSaveStatus] = useState(0)

    const [usemapRedirectURL, setUsemapRedirectURL] = useState('')

    const [trgFieldObj, setTrgFieldObj] = useState({
        fieldUID: usemap ? '' : field_pk,
        fieldType: '',
        fieldID: '',
        fieldName: ''
    })

    let initialCondObj = {
            ID: 1,    // maxID by default
            condition: 'and',
            rules: []
    }
    const [condObject, setCondObject] = useState<IBlock>(JSON.parse(JSON.stringify(initialCondObj)))    // use 'sampleData' as argument

    const [mapInfo, setMapInfo] = useState<any>({mapRemark: ''})
    useEffect(() => {
        // console.log('Comment: ', mapInfo.mapStatus)
    }, [mapInfo.mapRemark, mapInfo.mapStatus])


    useEffect(() => {
        if (usemap) {
            getUsemapSrcData()
        } else {
            getFieldMap()
        }
    }, [])


    let getFieldMap = async () => {
        let response = await fetch(`${serverIP}/getfieldmap/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(keyDataSet),
        })
        let data = await response.json()

        if (response.status === 200) {
            // console.log('Data:', data)
            setTrgFieldObj(prev => {
                return {...prev, fieldType: data.fieldType, fieldID: data.fieldID, fieldName: data.fieldName}    // trg field identifiers
            })

            setMapInfo(data['mapInfo'])    // comment and date of mapping

            if (data.mapRules !== null && data.mapRules.rules?.length > 0) {
                setCondObject(data.mapRules)
            }

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }


    let getUsemapSrcData = async () => {
        let response = await fetch(`${serverIP}/fieldusemapgetsrcdata/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({projUID: prjid, fieldUID: field_pk}),
        })
        let data = await response.json()

        if (response.status === 200) {
            // console.log('gonna put it now')
            setCondObject({
                ID: 0,
                condition: 'and',
                rules: [{
                    ID: 0,
                    fieldType: data.fieldType,
                    fieldName: `${data.fieldName} (${data.fieldID})`,
                    fieldID: data.fieldID,
                    valueCondition: '',
                    values: '',
                    useAS: '',
                    returnTemplate: '',
                    transformRules: ''
                }]
            })

            setTrgFieldObj((prevState: any) => {
                return {...prevState, fieldType: data.fieldType}
            })

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }


    function handleSave(event: any) {

        fetch(`${serverIP}/fieldsavemap/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({projUID: prjid, mapObj: condObject, trgObj: trgFieldObj, user: user.username}),
        }).then(res => res.json())
            .then((data) => {
                setSaveStatus(data.status)
                setMapInfo((prev: any) => {
                    return {...prev, mapStatus: 'mapped'}
                })
            })
    }

    useEffect(() => {
        if (saveStatus > 0) {
            const timeId = setTimeout(() => {
                navigate(  `../1`     )
                setSaveStatus(0)
            }, 3000)

            return () => {
                clearTimeout(timeId)
            }
        }
    }, [saveStatus])


    const readOnlyModeAlertStyle = {
        backgroundColor: "#fff5e6",
        color: "#804d00",
        fontSize: "0.84rem"
    }

    return (
        <>

            <BreadCrumbs user={user} itemsLinks={crumbItems} />

            {!userPermissions.canEdit && <Alert icon={false} style={readOnlyModeAlertStyle}>This is a "read only" mode. Changes cannot be saved. </Alert>}

            {usemap && !trgFieldObj.fieldUID && <Alert severity="warning">This is a "usemap" mapping. "Target Field Name" must be selected!</Alert>}

            {usemapRedirectURL && <Alert severity="warning">Selected target category is already mapped.
                Please, click <NavLink to={usemapRedirectURL} reloadDocument={true} className="grid-row-itemlink">here</NavLink> to check/update the mapping.</Alert>
            }

            {saveStatus === 200 && <Alert severity="success">The mapping has been saved!</Alert>}
            {saveStatus === 304 && <Alert severity="info">The mapping has not been modified.</Alert>}
            {saveStatus === 306 && <Alert severity="info">The mapping has been deleted.</Alert>}

            {mapInfo.mapStatus === 'parked' && <Alert severity="warning">Mapping status is: {mapInfo.mapStatus}.
                If you want to create mapping, please, "unpark" it.</Alert>}

            {mapInfo.mapRemark && <Alert severity="info">Mapping comment: {mapInfo.mapRemark}</Alert>}


            <div className="fieldmap-container">
                {/* Target Category Data */}
                <div className="fieldmap-trg-block">

                    <div className="fieldmap-trg-label">Taget Field Type:</div>
                    <input
                        name="fieldType"
                        type="text"
                        className="readonly-input"
                        value={trgFieldObj.fieldType}
                        readOnly
                    />

                    <div className="fieldmap-trg-label">Taget Field ID:</div>
                    <input
                        name="fieldID"
                        type="text"
                        className="readonly-input"
                        value={trgFieldObj.fieldID}
                        readOnly
                    />

                    <div className="fieldmap-trg-label">Taget Field Name:</div>
                    {usemap ?
                        <AutocOneFieldUsemap
                            name="fieldName"
                            mapData={keyDataSet}
                            trgFieldObj={trgFieldObj}
                            setTrgFieldObj={setTrgFieldObj}
                            setUsemapRedirectURL={setUsemapRedirectURL}
                        />
                        :
                        <input
                            name="fieldName"
                            type="text"
                            className="readonly-input"
                            value={trgFieldObj.fieldName}
                            readOnly
                        />
                    }
                </div>

                <div className="maptoolsbase-container">
                    <MapToolsBase
                        keyDataSet={keyDataSet}
                        mapInfo={mapInfo}
                        setMapInfo={setMapInfo}
                        // setCondObject={setCondObject}
                        // initialObjEmpty={initialCondObj}
                        featDefmapStatus={null}
                        setSaveStatus={setSaveStatus}
                    />
                </div>
            </div>


            {/* Mapping rules. If mapping is "parked" then no rules are shown */}
            {mapInfo.mapStatus !== 'parked' && (
                <div>
                    <div className="top-group-container">

                        <QueryGroup
                            condObject={condObject}
                            setCondObject={setCondObject}
                            currentGroup={condObject}
                            level={1}
                            currentRules={condObject.rules}
                            index={0}
                            mapData={keyDataSet}
                            dragElem={dragElem}
                        />
                    </div>

                    {userPermissions.canEdit && <>
                        <div className="btn-save-container">
                            <Button
                                type={(condObject.rules?.length === 0 || usemapRedirectURL) ? "secondary" : "primary"}
                                text="Save mapping"
                                onclick={(event: any) => handleSave(event)}
                                disabled={condObject.rules?.length === 0 || usemapRedirectURL !== ''}
                            />
                        </div>
                    </>
                    }

                </div>)
            }

        </>
    )
}
